import React, { useState, useContext } from "react";
import "./AdminLogin.css";
import { Stepper, Step } from "react-form-stepper";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../firebase.config";
import { Toaster, toast } from "react-hot-toast";
import OTPInput from "otp-input-react";
import { useNavigate } from "react-router-dom";
import clgocde_prici from "../../data/ccode_pno_map.json";
import userContext from "../../context/user-context";
import ClipLoader from "react-spinners/ClipLoader";
import {
	FiHash,
	FiLock,
	FiArrowRight,
	FiShield,
	FiTerminal,
	FiCheck
} from "react-icons/fi";

export const AdminLogin = () => {
	const { setuserclgcode, setCname } = useContext(userContext);

	const navigate = useNavigate();

	var clgname = "";

	const [stage1loader, setStage1loader] = useState(false);
	const [clgcode, setClgcode] = useState("");
	const [stepnumber, setstepnumber] = useState(0);
	const [priciphone, setPriciphone] = useState("");
	const [otp, setOtp] = useState();
	const [priciname, setPriciname] = useState("");

	const [password, setPassword] = useState("");

	const configureCaptchaVerify = () => {
		window.recaptchaVerifier = new RecaptchaVerifier(
			"sign-in-button",
			{
				size: "invisible",
				callback: (response) => {
					// reCAPTCHA solved, allow signInWithPhoneNumber.
					onSignInSubmit();
					console.log("Recaptcha verified");
				},
				defaultCountry: "IN"
			},
			auth
		);
	};

	const onSignInSubmit = (e) => {
		e.preventDefault();
		if (clgcode == "") {
			toast.error("Enter College Code");
			return;
		}

		var reqclg = clgocde_prici.find((clg) => clg.ccode.toString() == clgcode);
		if (reqclg == null || reqclg == undefined) {
			toast.error("College Code Doesnt exit");
			return;
		}
		setStage1loader(true);
		var phoneno = reqclg.pno.toString();
		var pname = reqclg.pname;
		configureCaptchaVerify();
		const phoneNumber = "+91" + phoneno;
		setPriciphone(phoneNumber);
		setPriciname(pname);
		console.log(phoneNumber);
		const appVerifier = window.recaptchaVerifier;
		signInWithPhoneNumber(auth, phoneNumber, appVerifier)
			.then((confirmationResult) => {
				// SMS sent. Prompt user to type the code from the message, then sign the
				// user in with confirmationResult.confirm(code).
				window.confirmationResult = confirmationResult;
				toast.success("OTP has been sent");
				console.log("OTP has been sent");
				setstepnumber(1);
				// ...
			})
			.catch((error) => {
				// Error; SMS not sent
				// ...
				toast.error("Too many login requests, Try after 1 hour");
				console.log(error);
				console.log("SMS not sent");
			});
	};

	const onSubmitOTP = (e) => {
		e.preventDefault();
		const code = otp;
		console.log(code);
		window.confirmationResult
			.confirm(code)
			.then((result) => {
				// User signed in successfully.
				const user = result.user;
				console.log(JSON.stringify(user));
				setuserclgcode(clgcode);
				navigate("/table");
				// ...
			})
			.catch((error) => {
				console.log(JSON.stringify(error));
				if (error) {
					toast.error("Invalid OTP");
				}

				// User couldn't sign in (bad verification code?)
				// ...
			});
	};

	const handleAdminLogin = () => {
		if (password === "admin@1234") {
			setuserclgcode(clgcode);
			navigate("/table");
		} else {
			toast.error("Invalid Password");
		}
	};

	return (
		<div className="auth">
			<Toaster
				toastOptions={{
					style: {
						background: "#ffffff",
						color: "#2c2722",
						border: "1px solid #ece3d4",
						boxShadow: "0 12px 30px -14px rgba(54,45,36,0.28)",
						fontFamily: "'IBM Plex Sans', sans-serif"
					}
				}}
			/>
			<div id="sign-in-button"></div>

			<div className="auth-grid">
				<aside className="auth-aside">
					<span className="auth-eyebrow">
						<span className="ping" /> Restricted Console
					</span>
					<h1 className="auth-headline">
						Administrator <span className="grad">access.</span>
					</h1>
					<p className="auth-desc">
						Elevated entry point for TNGASA operators. Authenticate to inspect
						any institution's allotment data and generate annexure reports on
						their behalf.
					</p>
					<ul className="auth-features">
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							Open any college code with master credentials
						</li>
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							Full annexure &amp; ranked-list generation
						</li>
						<li>
							<span className="ftick">
								<FiCheck />
							</span>
							Privileged, audit-aware operator session
						</li>
					</ul>
				</aside>

				<section className="auth-card">
					<span className="auth-badge">
						<FiTerminal /> Admin Console
					</span>
					<h2>Operator sign-in</h2>
					<p className="auth-card-sub">
						Enter a college code and the master administrator password.
					</p>

					<div className="steppercont">
						<Stepper
							activeStep={stepnumber}
							styleConfig={{
								activeBgColor: "#b5673b",
								completedBgColor: "#7c8a4e",
								inactiveBgColor: "#f6efe4",
								activeTextColor: "#ffffff",
								completedTextColor: "#ffffff",
								inactiveTextColor: "#9a9082",
								size: 30,
								labelFontSize: "12px"
							}}
						>
							<Step label="College Code" />
							<Step label="Authenticate" />
						</Stepper>
					</div>

					<div className="auth-fields">
						<div className="auth-field">
							<label>College Code</label>
							<div className="auth-input is-code">
								<FiHash />
								<input
									onChange={(e) => setClgcode(e.target.value)}
									type="text"
									placeholder="e.g. 1234"
								/>
							</div>
						</div>

						<div className="auth-field">
							<label>Administrator Password</label>
							<div className="auth-input">
								<FiLock />
								<input
									onChange={(e) => setPassword(e.target.value)}
									type="password"
									placeholder="Master password"
									onKeyDown={(e) => {
										if (e.key === "Enter") handleAdminLogin();
									}}
								/>
							</div>
						</div>

						<button className="auth-submit" onClick={handleAdminLogin}>
							Access Console <FiArrowRight />
						</button>
					</div>

					<div className="auth-foot">
						<FiShield />
						Privileged session · All administrator actions are logged
					</div>
				</section>
			</div>
		</div>
	);
};
